import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { VendorService } from '../../../services/vendor.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { PrintService } from '../../../services/print.service';

@Component({
	selector: 'app-all-vendors',
	templateUrl: './all-vendors.component.html',
	styleUrls: ['./all-vendors.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
		]),
	]
})
export class AllVendorsComponent implements OnInit {

	flip = 'inactive';
	@Output() viewData = new EventEmitter<any>();
	viewing: any = false;

	data: any = false;
	title = 'All Vendors';
	total: any = 0;
	includeInactive = false;
	config: any = [];
	user: any = false;
	exporting = false;
	@ViewChild('print_table') printtable: ElementRef;

	constructor(
		private globalSearchService: GlobalSearchService,
		private vendorService: VendorService,
		private printService: PrintService
	) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.globalSearchService.user.subscribe(u => {
				this.user = u;
			});
		});
	}

	ngOnInit(): void {
		this.reloadVendors();
	}

	reloadVendors(): void {
		this.vendorService.getVendorsPost({ inc_disabled: this.includeInactive }).subscribe((results: any) => {
			this.data = results;
			this.total = results.length;
		});
	}

	toggleFlip(data: any, title: string) {
		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title;
			const dashboard_data = { data: data, title: this.title };
			this.viewData.emit(dashboard_data);
		} else {
			this.viewData.emit(false);
		}
	}

	exportPdf() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'all-vendors.pdf',
			landscape: true,
			title: 'All Vendors',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.exporting = false;
		});
	}

	exportXls() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'all-vendors.xlsx',
			title: 'All Vendors',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.exporting = false;
		});
	}
}
